// @ts-expect-error Untyped import
import { trackSpecificPropertyEvent } from 'customer-data-sidebar/tracking/events';
import { CardAction } from 'commerce-subscription-cards-lib/cards/association';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { _tracker } from 'customer-data-tracking/tracker';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const SUBSCRIPTION_DEFAULT_ACTION_TEST_ID = 'SubscriptionCardAction-DefaultAction';
function handleTrackingAction(action) {
  trackSpecificPropertyEvent(_tracker, {
    action
  });
}
function SubscriptionCardActionWrapper(props) {
  const {
    toObjectTypeId,
    fromObjectTypeId,
    fromObjectId,
    associationTypeData,
    isUngated,
    hasScope,
    userPermissions,
    objectTypePermissions
  } = props;

  /**
   * We need create and edit split out, the canEditAssociation is a combination of create and edit permission which is
   * causing issues when we are trying to disable the add existing association button
   *
   * The canCreateAssociation is used to determine if the user can create the association.
   */
  const canEditSubscriptionAssociation = () => {
    /**
     * Contacts/Companies and Subscriptions have a special relationship in that changing the contact/company completely changes where we sent invoices/receipts,
     * and potentially how they are being paid because of payment method on file.
     */
    if ([CONTACT_TYPE_ID, COMPANY_TYPE_ID].includes(fromObjectTypeId)) {
      return userPermissions.currentUserCanEdit && userPermissions.currentUserCanEditAssociations && hasScope('subscriptions-write');
    } else {
      return userPermissions.currentUserCanEdit && userPermissions.currentUserCanEditAssociations;
    }
  };
  const canEditAssociation = canEditSubscriptionAssociation();
  const canCreateAssociation = userPermissions.currentUserCanEditAssociations || (objectTypePermissions === null || objectTypePermissions === void 0 ? void 0 : objectTypePermissions.currentUserCanCreate);

  // TODO: move these crm-message-bus calls into commerce-subscription-lib and simplify
  // this component
  const modifyAssociations = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_OBJECT_BUILDER);
  const updateAssociationCardData = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_ASSOCIATIONS);
  const openAssociationPanel = useCallback(() => {
    return modifyAssociations({
      objectTypeId: toObjectTypeId,
      association: {
        objectTypeId: fromObjectTypeId,
        objectId: fromObjectId,
        associationTypeId: associationTypeData.associationTypeId,
        associationCategory: associationTypeData.associationCategory
      }
    });
  }, [modifyAssociations, toObjectTypeId, fromObjectTypeId, fromObjectId, associationTypeData.associationTypeId, associationTypeData.associationCategory]);
  const refetchCardData = useCallback(() => updateAssociationCardData({
    objectTypeId: fromObjectTypeId,
    objectId: fromObjectId.toString(),
    toObjectTypeId
  }), [fromObjectTypeId, fromObjectId, toObjectTypeId, updateAssociationCardData]);
  return /*#__PURE__*/_jsx(CardAction, Object.assign({}, props, {
    hasGate: isUngated,
    hasScope: hasScope,
    trackEvent: handleTrackingAction,
    openAssociationPanel: openAssociationPanel,
    onClose: refetchCardData,
    "data-selenium-test": SUBSCRIPTION_DEFAULT_ACTION_TEST_ID,
    "data-test-id": SUBSCRIPTION_DEFAULT_ACTION_TEST_ID,
    canEditAssociation: canEditAssociation,
    canCreateAssociation: canCreateAssociation
  }));
}
export default SubscriptionCardActionWrapper;